import { ReactElement } from 'react';
import { Outlet } from 'react-router-dom';
import FilterTableProvider from 'shell/hooks/use-filter-table/provider';

export const initialValuesForeignState = {
  name: '',
  acronym: '',
  code: '',
  orders: {},
  page: 0,
  rowsPerPage: 10,
};

const PageForeignStateListInitializer = (): ReactElement => {
  return (
    <FilterTableProvider initialValues={initialValuesForeignState}>
      <Outlet />
    </FilterTableProvider>
  );
};

PageForeignStateListInitializer.displayName = 'Page Foreign State List initializer component';

export default PageForeignStateListInitializer;
